import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CustomColumn } from '@bd/shared/utils';
import { ParameterInputType, SetupParameterKindListViewModel, SetupParameterType } from 'chronos-basedata-client';
import { Observable } from 'rxjs';
import { Table as setupParameterTable } from '@bd/shared/models';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ListValue } from 'chronos-shared';
import { map } from 'rxjs/operators';
import { SetupParameterQuery } from '@bd/core/global-state/setup-parameter/setup-parameter.query';
import { SetupParameterColumnType } from '../../models/setup-parameter-column-type';

@Component({
  selector: 'app-edit-setup-parameter',
  templateUrl: './edit-setup-parameter.component.html',
  styleUrls: ['./edit-setup-parameter.component.scss']
})
export class EditSetupParameterComponent implements OnInit {

  @Input() public setupParameters$: Observable<SetupParameterKindListViewModel[]>;
  @Output() public updateSetupParameterEvent = new EventEmitter();
  @Output() formValidityChange = new EventEmitter<boolean>();

  public setupParameterTypeList: ListValue[] = [];
  public setupParameterTypeLoading = true;
  public inputTypeLoading = true;
  public inputTypeList: ListValue[] = [];
  public editAll: boolean = false;
  public formGroup: FormGroup;
  public rowFormGroups: FormGroup[] = [];
  public readonly SETUP_PARAMETER_COLUMN_TYPE = SetupParameterColumnType;

  columns: setupParameterTable[] = [
    new CustomColumn('description', 'SETUP_PARAMETER_HEADERS.DESCRIPTION', { styleClass: 'medium-cell' }),
    new CustomColumn('externalSetupParameterKindId', 'SETUP_PARAMETER_HEADERS.SETUP_PARAMETER_EXT_KIND_ID', { styleClass: 'medium-cell' }),
    new CustomColumn('externalWorkCenterId', 'SETUP_PARAMETER_HEADERS.SETUP_PARAMETER_EXT_WORKCENTER_ID', { styleClass: 'tiny-cell' }),
    new CustomColumn('setupParameterKindId', 'SETUP_PARAMETER_HEADERS.SETUP_PARAMETER_KIND_ID', { styleClass: 'tiny-cell' })
];

  constructor(
    public setupParameterQuery: SetupParameterQuery,
    private fb: FormBuilder) { }

  ngOnInit(): void {

    this.getSetupParameterTypes();
    this.getInputTypes();
    

    this.formGroup = this.fb.group({
      rows: this.fb.array([])
    });

    this.setupParameters$.subscribe((setupParameters) => {
      this.setFormRows(setupParameters);
    });

    this.formGroup.statusChanges.subscribe(() => {
      this.formValidityChange.emit(this.formGroup.valid);
    });
  }

  public checkValidity(rowIndex: number, columnName: string): boolean {
      if (this.editAll === false) return false;
  
      const control = this.formGroup.get('rows')?.get(rowIndex.toString())?.get(columnName);
  
      if (!control) {
        return false;
      }
  
      return control.invalid;
  }

  public onEditAll() {
    this.editAll = true;
    this.rows.controls.forEach((element) => {
      element.enable();
    });

    this.formGroup.updateValueAndValidity();
  }

  public onCancelEdit() {
    this.editAll = false;
    this.rows.controls.forEach((element) => {
      element.disable();
    });

    this.formGroup.updateValueAndValidity();
  }

  public get rows(): FormArray {
    return this.formGroup.get('rows') as FormArray;
  }

  public updateSetupParameter(newValue, setupParameter: SetupParameterKindListViewModel,
    setupParameterColumnType: SetupParameterColumnType) {
      switch (setupParameterColumnType) {
        case SetupParameterColumnType.SetupParameterType:
          const setupParamterOperationName = this.setupParameterTypeList.find((items) => items.value === newValue);
            if (setupParamterOperationName) {
                const enumValue = SetupParameterType[setupParamterOperationName.label as keyof typeof SetupParameterType];
                const updatedSetupParameter = { ...setupParameter, setupParameterType: enumValue };
                // setupParameter.setupParameterType = updatedSetupParameter.setupParameterType;
                // this.updateSetupParameterEvent.emit(updatedSetupParameter);
            }
          break;
        case SetupParameterColumnType.InputType:
          const operationName = this.inputTypeList.find((items) => items.value === newValue);
          if (operationName) {
              const enumInputValue = ParameterInputType[operationName.label as keyof typeof ParameterInputType];
              const updatedSetupParameter = { ...setupParameter, inputType: enumInputValue };
              // setupParameter.inputType = updatedSetupParameter.inputType;
              // this.updateSetupParameterEvent.emit(updatedSetupParameter);
          }
          break;
        case SetupParameterColumnType.Name:
          // setupParameter.setupParameterTemplateName = newValue;
          break;
        case SetupParameterColumnType.Description:
          setupParameter.description = newValue;
          break;
        default:
          console.info('default case executed');
          break;
    }
  }

  private destructureSetupParameter(): void {
    this.setupParameters$ = this.setupParameters$.pipe(
      map((setupParameters) =>
        setupParameters.map((item) => ({
          ...structuredClone(item)
        }))
      )
    );
  }

  private setFormRows(setupParameters: any[]) {
    console.info('Setup Parameters:', setupParameters); // Debugging

    const rows = this.formGroup.get('rows') as FormArray;
    rows.clear();
  
    setupParameters.forEach((parameter) => {
        rows.push(this.createRow(parameter));
    });
  }


  private createRow(parameter): FormGroup {
    return this.fb.group({
      description: new FormControl({ value: parameter.description, disabled: !this.editAll }, Validators.required),
      externalSetupParameterKindId: new FormControl({ value: parameter.externalSetupParameterKindId, disabled: !this.editAll },
        Validators.required),
      externalWorkCenterId: new FormControl({ value: parameter.externalWorkCenterId, disabled: !this.editAll }, Validators.required),
      setupParameterKindId: new FormControl({ value: parameter.setupParameterKindId, disabled: !this.editAll }, Validators.required),
      setupGroupId: new FormControl({ value: parameter.setupGroupId, disabled: !this.editAll }, Validators.required),
      rowVersion: [parameter.rowVersion]
    });
  }

  private getSetupParameterTypes() {
    this.setupParameterTypeLoading = true;
    this.setupParameterTypeList = [];
    const setupParameterType = Object.keys(SetupParameterType).map(key => ({ label: key, value: SetupParameterType[key] }));
    this.setupParameterTypeList = setupParameterType;
    this.setupParameterTypeLoading = false;
  }

  private getInputTypes() {
    this.inputTypeLoading = true;
    this.inputTypeList = [];

    const inputTypes = Object.keys(ParameterInputType).map(key => ({ label: key, value: ParameterInputType[key] }));
    this.inputTypeList = inputTypes;
    this.inputTypeLoading = false;
  }

}
